module.exports = __webpack_public_path__ + "img/right-single.f3130968.svg";